import {
  deleteInput,
  errorInput,
  focusInput,
  focusKeyboard,
  login,
  setStatus,
  updateInput
} from 'actions/login'
import classnames from 'classnames'
import AppBar from 'components/app-bar'
import Redirect from 'components/common/redirect'
import Focusable from 'components/focusable'
import Keyboard from 'components/keyboard'
import MainMenu from 'components/main-menu'
import Modal from 'components/modal'
import commonStyles from 'components/styles/common.css'
import styles from 'components/styles/login.css'
import modalStyles from 'components/styles/modal.css'
import { KEYBOARD_MODE_EMAIL, KEYBOARD_MODE_STANDARD } from 'constants/keyboard'
import {
  LOGIN_INPUT_PASSWORD,
  LOGIN_INPUT_USERNAME,
  LOGIN_STATUS_FAILED,
  LOGIN_STATUS_PROCESSING,
  LOGIN_STATUS_SUCCESS,
  LOGIN_STATUS_WAITING
} from 'constants/login'
import { Component } from 'preact'
import { route } from 'preact-router'
import { connect } from 'react-redux'
import { getP } from 'redux-polyglot'
import {
  getAppName,
  isLoggedIn,
  selectForceLogin,
  selectRemoveRegister
} from 'selectors/app'
import {
  getFocusedCol,
  getFocusedInput,
  getFocusedRow,
  getKeyboardFocused,
  getPassword,
  getPasswordError,
  getStatus,
  getUsername,
  getUsernameError
} from 'selectors/login'

class Login extends Component {

  constructor(props) {
    super(props)

    this.state = {
      isMainMenuOpen: false
    }
  }

  componentDidMount() {
    this.props.focusKeyboard(true)
  }

  getSourceQuery = () => {
    let source = []
    if (this.props.matches && this.props.matches.src) {
      source.push(`src=${this.props.matches.src}`)
      if (this.props.matches.ctgid) {
        source.push(`ctgid=${this.props.matches.ctgid}`)
      }
      if (this.props.matches.subid) {
        source.push(`subid=${this.props.matches.subid}`)
      }
      if (this.props.matches.tid) {
        source.push(`tid=${this.props.matches.tid}`)
      }
    }
    return source.join('&')
  }

  getRedirectUrl = _ => {

    let redirectUrl
    switch(this.props.matches.src) {
      case 'account':
        redirectUrl = `${__webpack_public_path__ || '/'}account`
        break
      case 'checkout':
        redirectUrl = `${__webpack_public_path__ || '/'}checkout`
        break
      case 'dvr':
        redirectUrl = `${__webpack_public_path__ || '/'}dvr`
        break
      case 'live':
        redirectUrl = `${__webpack_public_path__ || '/'}live`
        break
      case 'support':
        redirectUrl = `${__webpack_public_path__ || '/'}support`
        break
      case 'popular':
      case 'recent':
      case 'top':
      case 'ctg':
        redirectUrl = `${__webpack_public_path__ || '/'}video/watch/${this.props.matches.id}?${this.getSourceQuery()}`
        break
      case 'previews':
        redirectUrl = `${__webpack_public_path__ || '/'}checkout`
        break
      default:
        redirectUrl = `${__webpack_public_path__ || '/'}`
        break
    }

    return redirectUrl
  }

  inputHandleClick = (focusedInput, focusedRow, focusedCol) => event => {
    event.preventDefault()
    event.stopPropagation()
    this.props.focusInput(focusedInput, focusedRow, focusedCol)
  }

  keyboardHandleKeyDown = (event, key) => {
    if (key.action === 'delete') {
      if (
        (this.props.focusedInput === LOGIN_INPUT_USERNAME &&
          this.props.username !== '') ||
        (this.props.focusedInput === LOGIN_INPUT_PASSWORD &&
          this.props.password !== '')
      ) {
        this.props.deleteInput()
      } else {
        route(`${__webpack_public_path__ || '/'}`)
      }
    } else if (typeof key['key'] !== 'undefined') {
      this.props.updateInput(key['key'])
    }
  }

  keyboardHandleFocusDown = () => {
    !this.props.removeRegister && this.props.focusKeyboard(false)
  }

  login = event => {
    event.preventDefault()
    event.stopPropagation()
    if (!this.validateUsername()) {
      this.props.focusInput(LOGIN_INPUT_USERNAME, 0, 0)
    } else if (!this.validatePassword()) {
      this.props.focusInput(LOGIN_INPUT_PASSWORD, 0, 0)
    } else {
      this.props.login(this.props.username, this.props.password)
    }
  }

  goToHome = event => {
    event.preventDefault()
    event.stopPropagation()
    route(`${__webpack_public_path__ || '/'}`)
  }

  validateUsername = () => {
    const { polyglot: { t } } = this.props
    if (this.props.username === '') {
      this.props.errorInput(LOGIN_INPUT_USERNAME, t("tv_auth.error_username_email_empty", { _: "The username or email cannot be empty" }))
      return false
    } else {
      return true
    }
  }

  validatePassword = () => {
    const { polyglot: { t } } = this.props
    if (this.props.password === '') {
      this.props.errorInput(LOGIN_INPUT_PASSWORD, t("tv_auth.error_password_empty", { _: "The password cannot be empty" }))
      return false
    } else {
      return true
    }
  }

  getKeyboard = () => {
    const { polyglot: { t } } = this.props
    if (this.props.focusedInput === LOGIN_INPUT_USERNAME) {
      return <Keyboard
        title={this.props.usernameError ? this.props.usernameError : t("tv_auth.keyboard_label_username_email", { _: "Enter your username or email" })}
        titleError={this.props.usernameError !== ''}
        mode={KEYBOARD_MODE_EMAIL}
        focused={!this.state.isMainMenuOpen && this.props.keyboardFocused && this.props.status === LOGIN_STATUS_WAITING}
        focusedRow={this.props.focusedRow}
        focusedCol={this.props.focusedCol}
        handleFocusDown={this.keyboardHandleFocusDown}
        handleFocusLeft={this.openMainMenu}
        handleKeyDown={this.keyboardHandleKeyDown}
        handleTab={this.inputHandleClick(LOGIN_INPUT_PASSWORD, -1, -1)}
        shouldHandleDelete={this.props.username !== ''}
        actions={[
          { display: this.props.forceLogin ? t("tv_auth.keyboard_previous", { _: "Previous" }) : t("tv_auth.keyboard_go_to_home", { _: "Go to Home" }), length: 5, disabled: this.props.status === LOGIN_STATUS_PROCESSING || this.props.forceLogin, action: this.goToHome },
          { display: t("tv_auth.keyboard_next", { _: "Next" }), length: 5, disabled: this.props.status === LOGIN_STATUS_PROCESSING, action: this.inputHandleClick(LOGIN_INPUT_PASSWORD, -1, -1) }
        ]} />
    } else if (this.props.focusedInput === LOGIN_INPUT_PASSWORD) {
      return <Keyboard
        title={this.props.passwordError ? this.props.passwordError : t("tv_auth.keyboard_label_password", { _: "Enter your password" })}
        titleError={this.props.passwordError !== ''}
        mode={KEYBOARD_MODE_STANDARD}
        focused={!this.state.isMainMenuOpen && this.props.keyboardFocused && this.props.status === LOGIN_STATUS_WAITING}
        focusedRow={this.props.focusedRow}
        focusedCol={this.props.focusedCol}
        handleFocusDown={this.keyboardHandleFocusDown}
        handleFocusLeft={this.openMainMenu}
        handleKeyDown={this.keyboardHandleKeyDown}
        handleTab={this.inputHandleClick(LOGIN_INPUT_USERNAME, -1, -1)}
        shouldHandleDelete={this.props.password !== ''}
        actions={[
          { display: t("tv_auth.keyboard_previous", { _: "Previous" }), length: 5, disabled: this.props.status === LOGIN_STATUS_PROCESSING, action: this.inputHandleClick(LOGIN_INPUT_USERNAME, -1, 0) },
          { display: t("tv_auth.keyboard_login", { _: "Login" }), length: 5, disabled: this.props.status === LOGIN_STATUS_PROCESSING, action: this.login }
        ]} />
    }
  }

  openMainMenu = () => {
    this.setState({
      isMainMenuOpen: true
    })
  }

  closeMainMenu = () => {
    this.setState({
      isMainMenuOpen: false
    })
  }

  _getSourceQuery = () => {
    let source = []
    if (this.props.matches && this.props.matches.src) {
      source.push(`src=${this.props.matches.src}`)
      if (this.props.matches.ctgid) {
        source.push(`ctgid=${this.props.matches.ctgid}`)
      }
      if (this.props.matches.subid) {
        source.push(`subid=${this.props.matches.subid}`)
      }
      if (this.props.matches.tid) {
        source.push(`tid=${this.props.matches.tid}`)
      }
      if (this.props.matches.id) {
        source.push(`id=${this.props.matches.id}`)
      }
    }
    return source.join('&')
  }

  render({ polyglot: { t } }) {
    if (this.props.isLoggedIn || this.props.status === LOGIN_STATUS_SUCCESS) {
      return <Redirect to={this.getRedirectUrl()} />
    }
    return (
      <Focusable
        class="component"
        isFocused={false}
        onArrowLeft={() => this.openMainMenu()}>
        <div class="componentBody">
          <AppBar
            title={t("tv_auth.title_login", { _: "Login with Username or Email and Password" })}
            subtitle={t("tv_auth.subtitle_login", { _: "to continue with %{app_name}", app_name: this.props.appName })} />
          <div class={styles.container}>
            <div class={styles.left}>
              {this.getKeyboard()}
              {!this.props.removeRegister && (
                <Focusable
                  class={classnames("btn btnBlock btnIcon btnIconTop", styles.actionBtn)}
                  isFocused={!this.state.isMainMenuOpen && !this.props.keyboardFocused}
                  onEnter={() => route(`${__webpack_public_path__ || '/'}auth/register?${this._getSourceQuery()}`)}
                  onArrowUp={() => this.props.focusKeyboard(true)}>
                    <span class="signup"></span> {t("tv_auth.link_register", { _: "Don't have an account? Register one free" })}
                </Focusable>
              )}
            </div>
            <div class={styles.right}>
              <label class={commonStyles.label} htmlFor="username">{t("tv_auth.label_username_email", { _: "Username or email" })}</label>
              <div class={classnames(commonStyles.formControlWrapper, { [commonStyles.formControlSelected]: this.props.focusedInput === LOGIN_INPUT_USERNAME})}>
                <input
                  type="text"
                  id="username"
                  class={classnames(styles.formControl, { [commonStyles.formControlInvalid]: this.props.usernameError})}
                  value={this.props.username}
                  readOnly
                  maxLength="20"
                  onClick={this.inputHandleClick(LOGIN_INPUT_USERNAME)} />
              </div>

              <label class={commonStyles.label} htmlFor="username">{t("tv_auth.label_password", { _: "Password" })}</label>
              <div class={classnames(commonStyles.formControlWrapper, { [commonStyles.formControlSelected]: this.props.focusedInput === LOGIN_INPUT_PASSWORD})}>
                <input
                  type="password"
                  id="password"
                  class={classnames(styles.formControl, { [commonStyles.formControlInvalid]: this.props.passwordError})}
                  value={this.props.password}
                  readOnly
                  maxLength="20"
                  onClick={this.inputHandleClick(LOGIN_INPUT_PASSWORD)} />
              </div>
            </div>
          </div>
        </div>
        <MainMenu selectedItem="login" isOpen={this.state.isMainMenuOpen} close={this.closeMainMenu} />
        {this.props.status === LOGIN_STATUS_FAILED ?
          <Modal
            isFocused={false}>
            <div class={modalStyles.content}>
              <div class={modalStyles.title}>{t("tv_auth.login_failed_title", { _: "Login failed!" })}</div>
              <div class={modalStyles.message}>{t("tv_auth.login_failed_description", { _: "Please check your login information details and try again." })}</div>
            </div>
            <div class={modalStyles.btns}>
              <Focusable
                class={modalStyles.btn}
                isFocused={true}
                onBack={() => this.props.setStatus(LOGIN_STATUS_WAITING)}
                onEnter={() => this.props.setStatus(LOGIN_STATUS_WAITING)}
                onArrowLeft={null}
                onArrowRight={null}
                onArrowUp={null}
                onArrowDown={null}>
                OK
              </Focusable>
            </div>
          </Modal> : null
        }
        {this.props.status === LOGIN_STATUS_PROCESSING ?
          <Modal
            isFocused={true}
            onBack={null}
            onArrowLeft={null}
            onArrowRight={null}
            onArrowUp={null}
            onArrowDown={null}>
            <div class={modalStyles.content}>
              <div class={modalStyles.title}>{t("tv_auth.login_processing", { _: "Logging in, please wait ..." })}</div>
            </div>
          </Modal> : null
        }
      </Focusable>
    )
  }
}

const mapStateToProps = state => ({
  isLoggedIn: isLoggedIn(state),
  status: getStatus(state),
  focusedInput: getFocusedInput(state),
  username: getUsername(state),
  password: getPassword(state),
  usernameError: getUsernameError(state),
  passwordError: getPasswordError(state),
  keyboardFocused: getKeyboardFocused(state),
  focusedRow: getFocusedRow(state),
  focusedCol: getFocusedCol(state),
  polyglot: getP(state),
  appName: getAppName(state),
  forceLogin: selectForceLogin(state),
  removeRegister: selectRemoveRegister(state)
})

const mapDispatchToProps = {
  focusInput,
  updateInput,
  deleteInput,
  errorInput,
  login,
  setStatus,
  focusKeyboard
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
